<template>
  <div>
    <Headersys />
    <div class="content">
      <!-- <canvas class="canvas" id="qrCode" ref="qrCanvas"></canvas> -->
      <div>
        <div class="mingbai-box" v-if="print != '2'">
          <div style="width: 30vw">
            <div class="title">扫码打印营业执照</div>
            <img class="qrcoe-img" :src="codeImage" alt="" />
            <div class="tips">使用微信扫描二维码</div>
          </div>
          <div class="mingbai-content">
            <div class="mingbai-title">电子营业执照下载明白纸</div>
            <div class="mingbai-body">
              <div class="Apply-left">
                <div
                  class="iconfont-box"
                  @click="toLeft"
                  :class="{ end: current == 0 }"
                >
                  <div class="iconfont">&#xeb15;</div>
                </div>
              </div>
              <div class="content-admin" v-if="current == 0">
                <div style="font-size: 6rem">
                  1.微信扫描以下二维码，打开“电子营业执照“小程序
                </div>
                <img class="mingbai-img" src="@/assets/yyzz/1.png" alt="" />
              </div>
              <div class="content-admin" v-if="current == 1">
                <div style="font-size: 6rem">2.点击“下载执照”</div>
                <img class="mingbai-img" src="@/assets/yyzz/2.png" alt="" />
              </div>
              <div class="content-admin" v-if="current == 2">
                <div style="font-size: 6rem">
                  3.按照系统提示输入姓名、身份证号、手机号
                </div>
                <img class="mingbai-img" src="@/assets/yyzz/3.png" alt="" />
              </div>
              <div class="content-admin" v-if="current == 3">
                <div style="font-size: 6rem">
                  4.按照提示步骤，确认授权、刷脸、认证
                </div>
                <img class="mingbai-img" src="@/assets/yyzz/4.png" alt="" />
              </div>
              <div class="Apply-left">
                <div
                  class="iconfont-box"
                  @click="toRight"
                  :class="{ end: current == 3 }"
                >
                  <div class="iconfont">&#xe775;</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="loadDom" v-else>
          <img class="yyzz-img" :src="base64Data" alt="" />
        </div>
        <Back :print="print" @toPrintEve="userClice" />
      </div>
    </div>
  </div>
</template>
<script>
import { Loading } from "element-ui";
import lodop from "@/assets/js/doPrint";
export default {
  name: "",
  data() {
    return {
      //
      current: 0,
      qrid: "",
      codeImage: "",
      timer: null,
      loadingInstance: null,
      waitTime: 280,
      watiTimer: null,
      yyzzImg: "",
      form: {},
      print: "1",
      firmData: {}, //展示用企业信息
      fmac: "",
      phone: "",
      name: "",
      idCard: "",
      base64Data: "",
      debounceTimer: null,
      printPdfBase: "",
    };
  },
  created() {
    this.getQrCode();
    this.$fun.getMAC((mac) => {
      this.fmac = mac;
    });
    var userInfo = this.$store.state.suerInfo;
    this.name = userInfo.name;
    this.phone = userInfo.tel;
    this.idCard = userInfo.cerno;
  },
  mounted() {
    this.timeDown();
  },
  destroyed() {
    clearTimeout(this.timer);
    clearTimeout(this.watiTimer);
  },
  methods: {
    toLeft() {
      if (this.current == 0) {
        return;
      }
      this.current--;
    },
    toRight() {
      if (this.current == 3) {
        return;
      }
      this.current++;
    },
    userClice() {
      this.debounce(this.checkPrint, 1000);
    },
    // 防抖函数
    debounce(fn, wait) {
      if (this.debounceTimer !== null) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(fn, wait);
    },
    // 倒计时
    timeDown() {
      this.watiTimer = setInterval(() => {
        if (this.waitTime > 1) {
          this.waitTime--;
        } else {
          this.waitTime = 280;
          clearInterval(this.watiTimer);
          this.$router.replace("/");
        }
      }, 1000);
    },
    // 查询是否已打印
    checkPrint() {
      console.log("点击打印");
      this.loadingInstance = Loading.service({
        fullscreen: true,
        text: "正在打印...",
        target: document.querySelector("#loadDom"),
      });
      setTimeout(() => {
        this.loadingInstance.close();
      }, 20000);
      lodop.pdfPrint(this.printPdfBase);
      // lodop.yyzzPrint(this.base64Data)
      var obj = this.form;
      this.savePrintRecord(obj.uniscid, obj.entname);
      return;
      var obj = this.form;
      this.$rqt.print_getOne(obj.uniscid).then((res) => {
        if (!res.data) {
          this.loadingInstance = Loading.service({
            fullscreen: true,
            text: "正在打印...",
            target: document.querySelector("#loadDom"),
          });
          setTimeout(() => {
            this.loadingInstance.close();
          }, 20000);
          // 从这里打印
          lodop.pdfPrint(this.printPdfBase);
          // 查纸张数量
          this.checkZHI();
          this.savePrintRecord(obj.uniscid, obj.entname);
        } else {
          this.$alert("营业执照已打印，请勿重复打印！", "温馨提示", {
            confirmButtonText: "确定",
            lockScroll: false,
          });
        }
      });
    },
    //获取二维码
    getQrCode() {
      this.$rqt.agent_getQrInfo().then((res) => {
        var url = res.message_content.qrimage;
        this.qrid = res.message_content.qrid;
        this.codeImage = "data:image/jpg;base64," + url;
        this.getUsrInfo();
      });
    },
    // 轮询查询用户信息
    getUsrInfo() {
      this.$rqt.agent_receiveinfo(this.qrid).then((res) => {
        if (res.data) {
          const regex = /imageurl\s*=\s*(\S+)/;
          const match = res.data.messagecontent.match(regex);
          const imageUrl = match[1].replace(new RegExp(",", "g"), "");
          this.$rqt.common_getYYZZPDF(imageUrl).then((res) => {
            this.printPdfBase = res.message_content.licencePDF;
            this.$rqt
              .license_genPdfToJpg({
                base64: res.message_content.licencePDF,
              })
              .then((el) => {
                this.print = "2";
                console.log("pdf转图片", el);
                this.base64Data = "https://license.zwfwpt.cn/cc-api/" + el.msg;
                // this.base64Data = "http://112.243.253.8:8081/cc-api/" + el.msg
              });
          });
          var obj = JSON.parse(res.data.baseinfo);
          // this.print = '2'
          this.form = obj;
        } else {
          this.timer = setTimeout(() => {
            this.getUsrInfo();
          }, 2000);
        }
      });
    },
    checkZHI() {
      this.$rqt.Selfservice_count(this.fmac);
      this.$rqt.Selfservice_getByMac({ fmac: this.fmac }).then((res) => {
        var list = res.data;
        list.forEach((el) => {
          if (el.fcredentialsid == "yyzzzb") {
            if (el.fpaperqty < 6) {
              this.$rqt.common_sendSms(
                el.fphone,
                `${el.fname}设备。打印纸张还剩${el.fpaperqty}张，请及时添加。`
              );
            }
          }
        });
      });
    },
    savePrintRecord(uniscid, entName, printCount) {
      this.$rqt.print_save({
        uniscid,
        type: "打印营业执照",
        entName,
        fmac: this.fmac,
        name: this.name,
        phone: this.phone,
        idCard: this.idCard,
        printCount,
      });
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem);
  background-color: #fff;
  padding: 0 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.content::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.title {
  font-size: 10rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 3rem;
}

.qrcoe-img {
  display: block;
  width: 70rem;
  height: 70rem;
  // margin-bottom: 4rem;
  margin: 0 auto 4rem;
}

.tips {
  font-size: 6rem;
  font-weight: bold;
  text-align: center;
  color: red;
}

.goback-btn {
  width: fit-content;
  font-size: 8rem;
  background-color: #0099ff;
  border-radius: 2rem;
  margin: 10rem auto 0;
  font-weight: bold;
  color: #ffffff;
  padding: 3rem 5rem;
}

.yyzz-img {
  display: block;
  margin: auto;
  width: 58%;
  transform: translateY(-10rem);
}

// .canvas {
//   width: 200px !important;
//   height: 200px !important;
//   position: fixed;
//   top: -999rem;
//   left: -999rem;
// }

// .admin-tips {
//   position: fixed;
//   bottom: 30rem;
//   right: 10rem;
//   color: red;
//   font-size: 6rem;
//   font-weight: bold;
//   width: 120rem;
// }
.mingbai-box {
  width: 80vw;
  display: flex;
  align-items: center;

  .mingbai-content {
    width: calc(50vw - 100px);
    margin-left: 100px;

    .mingbai-body {
      display: flex;
      // align-items: center;
    }

    .mingbai-img {
      max-width: 100%;
      max-height: calc(100vh - 100rem);
      // height: calc(100vh - 100rem); //42
      display: block;
      margin: 20px auto 0;
    }
  }
}

.mingbai-box::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.Apply-left {
  width: 100px;
  height: calc(100vh - 72rem);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.iconfont-box {
  width: 25rem;
  height: 25rem;
  line-height: 25rem;
  text-align: center;
  border-radius: 50%;
  background-color: #f5f5f5;

  .iconfont {
    font-size: 12rem;
  }
}

.end {
  opacity: 0.5;
}

.content-admin {
  width: 500px;
  margin: 0 20px;
}

.mingbai-title {
  width: fit-content;
  text-align: center;
  font-weight: bold;
  font-size: 8rem;
  // margin-bottom: 10px;
  margin: 0 auto 10px;
  padding: 10px;
  border-radius: 10px;
  // border: 2px solid red;
  // background-color: red;
  color: #1a32c4;
  background: linear-gradient(to bottom, #c7e0fc, #e5effb);
}
</style>
